import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element'
import './styles/index.scss'
import './router/permission'
import * as echarts from 'echarts'
import dialogDragResize from './directives/dialogDragResize'

Vue.prototype.$echarts = echarts
Vue.directive('dialog-drag-resize', dialogDragResize)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
